<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Add Button Text">
      <b-form-input
        @change="changeProp"
        label="Add Button Text"
        v-model="field.add_text"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Maximum Entires">
      <b-form-input
        @change="changeProp"
        min="0"
        step="1"
        type="number"
        v-model="field.params.max"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Minimum Entries">
      <b-form-input
        @change="changeProp"
        min="0"
        step="1"
        type="number"
        v-model="field.params.min"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Widgets">
      <f-child-fields
        :fields="field.fields"
        @change="on_changed_fields"
        @select="on_select"
      />
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";
import FChildFields from "../FChildFields.vue";

export default {
  name: "RepeatProps",
  components: { FChildFields, WidgetCommonProps },
  mixins: [WidgetPropMixin],
};
</script>
